import React from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import styles from './LandingPageV4.module.css';

const IMAGES = {
  delivery: '/images/delivery.webp',
  pickup: '/images/pickup.webp',
};

const OrderOptions = ({ onDeliveryClick, onPickupClick, onOrderClick }) => {
  const handleDeliveryClick = onDeliveryClick || onOrderClick;
  const handlePickupClick = onPickupClick || onOrderClick;

  return (
    <section
      className={styles.orderOptions}
      aria-labelledby="order-options-title"
    >
      <div className={styles.innerWrapper}>
        <div className={styles.orderOptionsHeader}>
          <div>
            <p className={styles.sectionEyebrow}>Your order, your rhythm</p>
            <h2 id="order-options-title" className={styles.sectionTitle}>
              Fast when you need it. Flexible when you don’t.
            </h2>
          </div>
          <p className={styles.sectionSubtitle}>
            Shop the same nearby inventory, then choose the handoff that fits
            your day.
          </p>
        </div>
        <div className={styles.orderOptionsGrid}>
          <article className={styles.orderCard}>
            <img
              className={styles.orderCardImageFull}
              src={IMAGES.delivery}
              alt="Professional delivery vehicle in a clean urban environment"
              loading="lazy"
              decoding="async"
              width="1200"
              height="1200"
            />
            <div className={styles.orderCardOverlay} />
            <div className={styles.orderCardContentOverlay}>
              <div className={styles.orderCardTopline}>
                <span className={styles.orderCardNumber}>01</span>
                <span className={styles.orderCardMode}>
                  <LocalShippingIcon sx={{ fontSize: 15 }} aria-hidden="true" />
                  To your door
                </span>
              </div>
              <div className={styles.orderCardBadge}>
                Partnered with Uber Direct
              </div>
              <h3 className={styles.orderCardTitle}>On-Demand Delivery</h3>
              <p className={styles.orderCardText}>
                Your favorite smokes and vapes delivered from local shops to your door via Uber Direct.
              </p>
              <button type="button" className={styles.orderCardBtnPrimary} onClick={handleDeliveryClick}>
                Order Delivery
                <ArrowForwardIcon sx={{ fontSize: 19 }} aria-hidden="true" />
              </button>
            </div>
          </article>

          <article className={styles.orderCard}>
            <img
              className={styles.orderCardImageFull}
              src={IMAGES.pickup}
              alt="Modern premium smoke shop interior"
              loading="lazy"
              decoding="async"
              width="1200"
              height="1200"
            />
            <div className={styles.orderCardOverlay} />
            <div className={styles.orderCardContentOverlay}>
              <div className={styles.orderCardTopline}>
                <span className={styles.orderCardNumber}>02</span>
                <span className={styles.orderCardMode}>
                  <AccessTimeIcon sx={{ fontSize: 15 }} aria-hidden="true" />
                  Ready when you are
                </span>
              </div>
              <h3 className={styles.orderCardTitle}>In-Store Pickup</h3>
              <p className={styles.orderCardText}>
                Skip the wait and grab your essentials from the counter in minutes.
              </p>
              <button type="button" className={styles.orderCardBtnOutline} onClick={handlePickupClick}>
                Find Pickup Near Me
                <ArrowForwardIcon sx={{ fontSize: 19 }} aria-hidden="true" />
              </button>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default OrderOptions;
